import React from 'react'
import PropTypes from 'prop-types'

import { Divider, Grid, Label } from 'semantic-ui-react'
import { Link } from 'react-router-dom'
import { CRUDShow } from '../../CRUD'

const Informacoes = (props) => {
  const { comercializadora, uf } = props
  return (
    <CRUDShow noTitle padded={false}
      onEditResource={() => props.onEditResource(comercializadora.id)}
      onDeleteResource={() => props.onDeleteResource(comercializadora.id)}>
      <Grid columns='equal'>
        <Grid.Column width={16}>
          <Divider horizontal>Dados Principais</Divider>
        </Grid.Column>

        <Grid.Row>
          <Grid.Column textAlign='right' width={2}>
            <strong>Sigla</strong>
          </Grid.Column>
          <Grid.Column width={2}>
            {comercializadora.sigla}
          </Grid.Column>

          <Grid.Column textAlign='right' width={3}>
            <strong>Nome/Razão Social</strong>
          </Grid.Column>
          <Grid.Column width={9}>
            {comercializadora.nome}
          </Grid.Column>
        </Grid.Row>

        <Grid.Row>
          <Grid.Column textAlign='right' width={2}>
            <strong>CNPJ</strong>
          </Grid.Column>
          <Grid.Column width={3}>
            {comercializadora.cnpj}
          </Grid.Column>
          <Grid.Column textAlign='right' width={2}>
            <strong>CCEE</strong>
          </Grid.Column>
          <Grid.Column width={9}>
            {comercializadora.ccee}
          </Grid.Column>
        </Grid.Row>

        <Grid.Row>
          <Grid.Column width={16}>
            <Divider horizontal>Endereço</Divider>
          </Grid.Column>
        </Grid.Row>

        <Grid.Row>
          <Grid.Column textAlign='right' width={2}>
            <strong>Endereço</strong>
          </Grid.Column>
          <Grid.Column width={8}>
            {comercializadora.endereco}
          </Grid.Column>

          <Grid.Column textAlign='right' width={2}>
            <strong>CEP</strong>
          </Grid.Column>
          <Grid.Column width={4}>
            {comercializadora.cep}
          </Grid.Column>
        </Grid.Row>

        <Grid.Row>
          <Grid.Column textAlign='right' width={2}>
            <strong>Bairro</strong>
          </Grid.Column>
          <Grid.Column width={2}>
            {comercializadora.bairro}
          </Grid.Column>

          <Grid.Column textAlign='right' width={3}>
            <strong>Cidade</strong>
          </Grid.Column>
          <Grid.Column width={4}>
            {comercializadora.cidade}
          </Grid.Column>

          <Grid.Column textAlign='right' width={1}>
            <strong>UF</strong>
          </Grid.Column>
          <Grid.Column width={4}>
            <Label as={Link} to={`/uf/${uf.id}`}>
              {uf.sigla}
            </Label>
          </Grid.Column>
        </Grid.Row>

        <Grid.Row>
          <Grid.Column width={16}>
            <Divider horizontal>Dados Bancários</Divider>
          </Grid.Column>
        </Grid.Row>

        <Grid.Row>
          <Grid.Column textAlign='right' width={2}>
            <strong>Banco</strong>
          </Grid.Column>
          <Grid.Column width={2}>
            {comercializadora.banco}
          </Grid.Column>

          <Grid.Column textAlign='right' width={3}>
            <strong>Agência</strong>
          </Grid.Column>
          <Grid.Column width={4}>
            {comercializadora.agencia}
          </Grid.Column>

          <Grid.Column textAlign='right' width={1}>
            <strong>Conta</strong>
          </Grid.Column>
          <Grid.Column width={4}>
            {comercializadora.conta}
          </Grid.Column>
        </Grid.Row>

        <Grid.Row>
          <Grid.Column width={16}>
            <Divider horizontal>Dados Adicionais</Divider>
          </Grid.Column>
        </Grid.Row>

        <Grid.Row>
          <Grid.Column textAlign='right' width={2}>
            <em>Criado em</em><br />
            <em>Atualizado em</em>
          </Grid.Column>
          <Grid.Column>
            {comercializadora.created_at}<br/>
            {comercializadora.updated_at}
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </CRUDShow>
  )
}

Informacoes.propTypes = {
  uf: PropTypes.object,
  comercializadora: PropTypes.object,
  onEditResource: PropTypes.func.isRequired,
  onDeleteResource: PropTypes.func.isRequired
}

export default Informacoes
